import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {NGXLogger} from 'ngx-logger';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {AuthenticationService} from '../../../services/authentication.service';
import {AuxiliarService} from '../../../services/auxiliar.service';
import {TranslateService} from '@ngx-translate/core';
import {distinctUntilChanged} from 'rxjs';
import {passwordValidator} from '../../../utils/validators/passwordValidator';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChangePasswordModalComponent implements OnInit {
  public form: FormGroup;
  public loading: boolean;

  get f(): { [index: string]: any } {
    return this.form.controls;
  }

  constructor(private logger: NGXLogger, private formBuilder: FormBuilder, private dialogService: DynamicDialogRef,
              private authenticationService: AuthenticationService, private auxiliarService: AuxiliarService,
              private translate: TranslateService) {
  }

  // function to cancel changes
  public cancel(): void {
    this.dialogService.close();
  }

  // function to save changes
  public save(): void {
    this.loading = true;
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.authenticationService.changeUserPassword(this.form.value).subscribe({
        next: (res) => {
          this.logger.debug('[authenticationService] changeUserPassword res: ', res);
          // toast message
          this.auxiliarService.toast(this.translate.instant('success.password-change'), 'success');
          // close modal
          this.dialogService.close();
        },
        error: (err) => {
          this.logger.error('[authenticationService] changeUserPassword err: ', err);
          // toast message
          this.auxiliarService.toast(this.translate.instant('error.password-change'), 'error');
          this.loading = false;
        }
      });
    }
  }

  // function to load form
  private loadForm(): void {
    this.form = this.formBuilder.group({
      passNew: ['', [Validators.required]],
      passNewRepeat: ['', []],
    });

    // fields validators
    this.f['passNewRepeat'].setValidators([Validators.required, passwordValidator(this.f['passNew'])]);

    // fields value changes
    this.f['passNew']
      .valueChanges.pipe(distinctUntilChanged())
      .subscribe((value: any) => {
        this.f['passNewRepeat'].updateValueAndValidity();
      });
  }

  ngOnInit(): void {
    // load form
    this.loadForm();
  }
}
